<script setup>
import MarketingBlock from "~/components/organisms/MarketingBlock.vue";
import CollectionsPreviewBasicBlock from "~/components/organisms/CollectionsPreviewBasicBlock.vue";
import Text from "~/components/atoms/Text.vue";
import Heading from "~/components/atoms/Heading.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import {useRoute} from 'vue-router';
import {fetchWithErrorHandling} from '~/composables/fetchWithErrorHandling';

const {t} = useI18n();
const route = useRoute();

const page = ref(parseInt(route.query.page, 10) || 1)

const data = await fetchWithErrorHandling('collection', {
  lazy: false,
  query: {
    page
  }
})

useHead({
  title: t('collection.alternative_collection'),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: t('collection.meta_description')
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      children: data.value.breadcrumbs_structured_data
    },
  ]
})

const total = computed(() => data.value ? data.value.total : []);
const per_page = computed(() => data.value ? data.value.per_page : []);
const current_page = computed(() => data.value ? data.value.current_page : []);
const pages_count = computed(() => data.value ? data.value.pages_count : []);
const collections = computed(() => data.value ? data.value.collections : []);

const {breadcrumbs, banners, counter} = data.value

watch(collections, () => {
  window.scrollTo(0, 0);
}, {deep: true});
</script>

<template>
  <div class="big-page-wrapper">
    <div class="page-wrapper">
      <div class="container g-32">
        <MarketingBlock :banner-slots="[0,1]" v-if="counter || !$device.isMobile" :counter="counter"
                        :banners="$device.isMobile ? [] : banners"/>

        <div>
          <div class="g-8">
            <Heading>{{ $t('collection.most_popular') }}</Heading>
            <Text>{{ $t('collection.list_sub_title') }}</Text>
          </div>
          <CollectionsPreviewBasicBlock :no-carousel="true" :key="page" :collections="collections"
                                        :menu_items="[]"/>
        </div>

        <Pagination @change="page = $event" :current-page="current_page"
                    :count="per_page"
                    :items-per-page="per_page" :total-items="total"
                    :total-pages="pages_count"/>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
